<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <div>
    <div class="row">
      <div class="col-12">
        <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
          <li class="nav-item col-6 px-0">
            <router-link
              :to="'/sertifikasi/jadwal-tc/sesi-1/'+this.$route.params.id_jadwal_tc"
              class="nav-link p-3 px-5 font-weight-bold text-white border-0"
              style="display: flex; justify-content: center; align-items: center;"
              id="home-tab"
              data-toggle="tab"
              href="#home"
              role="tab"
              aria-controls="home"
              aria-selected="true"
            >Sertifikasi</router-link>
          </li>
          <li class="nav-item col-6 px-0">
            <router-link
              :to="'/sertifikasi/jadwal-tc/rpl-sesi-satu/'+this.$route.params.id_jadwal_tc"
              class="nav-link p-3 px-5 font-weight-bold text-white"
              style="background-color: #486ba7; display: flex; justify-content: center; align-items: center;"
              id="profile-tab"
              data-toggle="tab"
              href="#profile"
              role="tab"
              aria-controls="profile"
              aria-selected="false"
            >RPL</router-link>
          </li>
        </ul>
      </div>
    </div>
    <CCard>
      <!-- Tabs -->
      <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
        <li class="nav-item">
          <div
            
            class="nav-link p-3 px-5 font-weight-bold text-white border-0"
            :style="actionTabSesi == 'Sesi - 1' ? 'background-color: #486ba7' : ''"
            id="home-tab"
            data-toggle="tab"
            href="#home"
            role="tab"
            aria-controls="home"
            aria-selected="false"
            @click="changeSesi('Sesi - 1')"
          >Sesi 1</div>
        </li>
        <li class="nav-item">
          <div
            @click="changeSesi('Sesi - 2')"
            class="nav-link p-3 px-5 font-weight-bold text-white"
            :style="actionTabSesi == 'Sesi - 2' ? 'background-color: #486ba7' : ''"
            id="profile-tab"
            data-toggle="tab"
            href="#profile"
            role="tab"
            aria-controls="profile"
            aria-selected="false"
          >Sesi 2</div>
        </li>
        <li class="nav-item">
          <div
            @click="changeSesi('Sesi - 3')"
            class="nav-link p-3 px-5 font-weight-bold text-white"
            id="contact-tab"
            data-toggle="tab"
            href="#contact"
            role="tab"
            :style="actionTabSesi == 'Sesi - 3' ? 'background-color: #486ba7' : ''"
            aria-controls="contact"
            aria-selected="false"
          >Sesi 3</div>
        </li>
      </ul>

      <CCardBody>
        <CRow>
          <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            <CSelect
              label="Data Perhalaman"
              class="float-left"
              @change="changePageSize"
              :options="[10, 25, 100, 'Semua Data']"
            />
          </div>
        </div>
        <div class="col-sm-12 col-xl-3">
          <div class="form-group">
            <label for>Pencarian</label>
            <input
              type="text"
              name
              id
              class="form-control"
              placeholder="Cari Data ..."
              @keyup="cariData"
              v-model="search"
            />
          </div>
        </div>
          <div class="col-lg-7 col-sm-12 d-flex align-items-center">
            <!-- <CButton color="info" style="float:right;margin-right:10px" class="btn-md ml-auto">Print</CButton> -->
            <!-- <CButton color="danger" style="float:right;margin-right:10px" class="btn-md ml-auto">Export PDF</CButton>
            <CDropdown
              toggler-text="Ekspor Excel"
              color="warning"
              class="mr-2 d-inline-block text-white float-right"
            >
              <CDropdownItem>Export All</CDropdownItem>
              <CDropdownItem>Export Page</CDropdownItem>
            </CDropdown> -->
            <router-link to="/sertifikasi/jadwal-tc/upload-absensi-rpl">
              <CButton
                color="warning"
                style="float:right;margin-right:10px"
                class="btn-md btn-upload text-white"
              >UPLOAD ABSENSI</CButton>
            </router-link>
          </div>
        </CRow>
        <CRow>
          <CCol lg="12" class="table-responsive">
            <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
              <template #no="{item, index}">
                <td class="py-2">{{ index+1 }}</td>
              </template>
              <template #no_anggota="{item}">
                <td class="py-2 text-center">{{item.no_anggota ? item.no_anggota : '-'}}</td>
              </template>
              <template #nama_lengkap="{item}">
                <td class="py-2 text-center">{{item.nama_lengkap ? item.nama_lengkap : "-"}}</td>
              </template>
              <template #nama_level="{item}">
                <td class="py-2 text-center">{{item.nama_level ? item.nama_level : "-"}}</td>
              </template>
              <template #no_handphone="{item}">
                <td class="py-2 text-center">{{item.no_handphone ? item.no_handphone : "-"}}</td>
              </template>
              <template #kehadiran="{item}">
                <td class="py-2">
                  <button class="btn btn-sm btn-success" v-if="item.kehadiran == '1'">YA</button>
                  <button class="btn btn-sm btn-danger" v-else-if="item.kehadiran == '0'">TIDAK</button>
                  <button class="btn btn-sm btn-dark" v-else>Belum Absen</button>
                </td>
              </template>
              <template #nama_rpl="{item}">
                <td class="py-2 text-center">{{item.nama_rpl ? item.nama_rpl : "-"}}</td>
              </template>
              <template #mata_uji="{item}">
                <td class="py-2 text-center">
                  <div v-for="value in item.mata_uji" :key="value.nama_mata_uji" :value="value.nama_mata_uji">
                    {{value.nama_mata_uji ? value.nama_mata_uji : "-"}}
                  </div>
                </td>
              </template>
              <template #tombol_dokumen_terverifikasi="{item}">
                <td class="py-2">
                  <button
                    class="btn btn-sm btn-success"
                    v-if="item.tombol_dokumen_terverifikasi == 1"
                  >Terverifikasi</button>
                  <button class="btn btn-sm btn-danger" v-else>Belum Terverifikasi</button>
                </td>
              </template>
              <template #aksi="{item}">
                <td class="py-2 d-flex align-items-center">
                  <CButton
                    color="warning"
                    class="btn-sm text-white"
                    square
                    @click="sendEmail(item)"
                  >
                    <font-awesome-icon icon="envelope" />
                  </CButton>&nbsp;&nbsp;
                  <CButton color="success" class="btn-sm mx-1" square @click="verifikasiDokumen(item.id_trans_sertifikasi_peserta)">
                    <i class="fa fa-file" aria-hidden="true"></i>
                  </CButton>&nbsp;&nbsp;
                  <CButton color="info" class="btn-sm" square @click="updateDataKehadiran(item)">
                    <font-awesome-icon icon="edit" />
                  </CButton>&nbsp;&nbsp;
                </td>
              </template>
            </CDataTable>
         
            <CPagination
              style="float:right"
              :active-page.sync="currentPage"
              :pages="pagination.totalPages"
              responsive
              @click="pageChange"
            />
          </CCol>
        </CRow>
        <!-- Modal Edit -->
        <CModal
          title="Modal title"
          :show.sync="myModal"
          :no-close-on-backdrop="true"
          :centered="true"
        >
          <CForm @submit.prevent="putDataKehadiran">
            <CRow>
              <div class="modal-body">
                <form>
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label for="name font-weight-bold" class="font-weight-bold">Nama</label>
                      <input
                        type="text"
                        v-model="formDataKehadiran.nama_lengkap"
                        class="form-control"
                        id="name"
                        disabled
                      />
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label for="sesi1" class="font-weight-bold">Kehadiran</label>
                      <select class="form-control" name id v-model="formDataKehadiran.kehadiran">
                        <option selected disabled>Pilih Kehadiran</option>
                        <option value="1" :selected="formDataKehadiran.kehadiran == '1'">YA</option>
                        <option value="0" :selected="formDataKehadiran.kehadiran == '0'">TIDAK</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label for="sertifikasi" class="font-weight-bold">Sertifikasi</label>
                      <input
                        type="text"
                        v-model="formDataKehadiran.nama_rpl"
                        class="form-control"
                        id="sertifikasi"
                        disabled
                      />
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label for class="font-weight-bold">Mata Uji</label>
                      <br />
                      <ol class="ol-custom pl-3">
                        <li
                          class="li-custom"
                          v-for="value in formDataKehadiran.mata_uji" :key="value.nama_mata_uji" :value="value.nama_mata_uji"
                        >{{value.nama_mata_uji ? value.nama_mata_uji : "-"}}</li>
                      </ol>
                    </div>
                  </div>
                </form>
              </div>
            </CRow>
          </CForm>
          <template #header>
            <h6 class="modal-title h4 font-weight-bold">Edit</h6>            
          </template>
          <template #footer>
            <CButton @click="myModal = false" color="danger">Tutup</CButton>
            <CButton @click="putDataKehadiran()" type="submit" color="success">Simpan</CButton>
          </template>
        </CModal>
        <!-- End Modal -->

        <!-- Modal Email -->
        <CModal
        title="Modal title"
        :show.sync="modalEmail"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm v-on:submit.prevent="postDataEmail">
          <CRow>
            <CCol sm="12">
              <CInput
                class="font-weight-bold"
                label="Subjek"
                placeholder="Masukkan Subjek"
                v-model="formEmail.subject"
              />
            </CCol>
            <CCol sm="12">
              <CTextarea
                class="font-weight-bold"
                label="Pesan"
                rows="3"
                placeholder="Masukkan isi pesan"
                v-model="formEmail.text"
              />
            </CCol>

            <CCol sm="12 mb-5">
              <label for="uid-zwqayuopq3" class="font-weight-bold">File (Opsional)</label>
              <br />
              <div class="custom-file text-truncate">
                <input
                  type="file"
                  class="custom-file-input"
                  id="customFileLangHTML"
                  @change="fileUpload"
                />
                <label
                  class="custom-file-label"
                  for="customFileLangHTML"
                  data-browse="Unggah"
                >{{ fileName }}</label>
              </div>
              <small class="text-danger">*File harus berupa PDF max 10MB</small>
            </CCol>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Kirim Email</h6>
          <CButtonClose @click="modalEmail = false" class="text-white" />
        </template>
        <template #footer class="mt-5">
          <CButton @click="modalEmail = false" color="danger">Tutup</CButton>
          <CButton @click="postDataEmail" type="submit" color="success">Kirim</CButton>
        </template>
      </CModal>
        <!-- End Modal -->

        <!-- Modal Verif -->
        <CModal
          title="Modal title"
          :show.sync="modalVerif"
          :no-close-on-backdrop="true"
          :centered="true"
        >
          <CForm @submit.prevent="aksiVerifikasiDokumen">
            <CRow 
              v-for="value in formDataDokumen.dokumenPendukungRplPesertaRequest"
              :key="value.idDokumenPendukungRpl" 
              :value="value.idDokumenPendukungRpl">
                <CCol sm="12">
                  <label for class="font-weight-bold">{{value.namaDokumen}}</label>
                  <br />
                    <div class="text-center d-block">
                        <img src="/img/ic_pdf.png" width="100px" alt="icon" srcset />
                        <br />
                        <a style="color:blue;" v-if="value.file != '' && value.file != null" :href="baseUrl+'/dokumen_persyaratan_rpl/'+value.file" target="_blank"
                        >
                          Lihat File
                        </a>
                        <a style="color:blue;" v-else
                            @click="dataTidakAda()"
                        >
                          Lihat File
                        </a>
                    </div>
                </CCol>
                <CCol sm="12 mb-4 mt-3">
                  <label for class="font-weight-bold">Status</label>
                  <br />
                  <select name="" v-model="value.statusUpload" class="form-control mb-2">
                    <option value="0" :selected="value.statusUpload == '0'">Belum Upload</option>
                    <option value="1" :selected="value.statusUpload == '1'">Terverifikasi</option>
                    <option value="2" :selected="value.statusUpload == '2'">Sudah Upload</option>
                    <option value="3" :selected="value.statusUpload == '3'">File Tidak Terbaca</option>
                    <option value="4" :selected="value.statusUpload == '4'">File Tidak Sesuai</option>
                  </select>
                </CCol>
            </CRow>
          </CForm>
          <template #header>
            <h6 class="modal-title h4 font-weight-bold">Verifikasi</h6>            
          </template>
          <template #footer>
            <CButton @click="modalVerif = false" color="danger">Tutup</CButton>
            <CButton type="submit" color="success" @click="aksiVerifikasiDokumen">Simpan</CButton>
          </template>
        </CModal>
        <!-- End Modal -->
      </CCardBody>
      <!-- End Data sesi 3 -->
    </CCard>
  </div>
</template>
<script>
import MasterJadwalTcService from "../../../services/sertifikasi/jadwal-tc-peserta.service.js";
import DataPesertaService from "../../../services/sertifikasi/data-peserta.service";
import baseUrl from "../../../services/base-url";
import Utils from "../../../services/utils.service";

const fields = [
  {
    key: "no",
    sorter: true,
    filter: false,
    _style: "vertical-align: middle;"
  },
  {
    key: "no_anggota",
    label: "No.Anggota",
    sorter: true,
    filter: false,
    _style: "vertical-align: middle;"
  },
  {
    key: "nama_lengkap",
    label: "Nama",
    sorter: true,
    filter: false,
    _style: "vertical-align: middle;"
  },
  {
    key: "nama_level",
    label: "Level",
    sorter: true,
    filter: false,
    _style: "vertical-align: middle;"
  },
  {
    key: "no_handphone",
    label: "No. Telepon",
    sorter: true,
    filter: false,
    _style: "vertical-align: middle;"
  },
  {
    key: "kehadiran",
    label: "Kehadiran",
    sorter: true,
    filter: false,
    _style: "vertical-align: middle;"
  },
  {
    key: "nama_rpl",
    label: "Sertifikasi",
    sorter: true,
    filter: false,
    _style: "vertical-align: middle;"
  },
  {
    key: "mata_uji",
    label: "Mata Uji",
    sorter: true,
    filter: false,
    _style: "vertical-align: middle;"
  },
  {                                                                                                                                                       
    key: "tombol_dokumen_terverifikasi",
    label: "Persyaratan Dokumen",
    sorter: true,
    filter: false,
    _style: "vertical-align: middle;"
  },
  {
    key: "aksi",
    _style: "width:10%; vertical-align: middle;",
    sorter: false,
    filter: false
  }
];

export default {
  name: "JTC_Sesi1",
  data() {
    return {
      actionTabSesi : 'Sesi - 1',
      fileName: "Pilih File...",
      search: "default",
      items: [],
      TestCenter: [],
      actionPost: "",
      namaTc: [],
      pageSize : 10,
      formEmail: {
        to: "",
        subject: "",
        text: "",
        attacment: ""
      },
      formDataKehadiran: {
        idJadwalTc: "",
        idRplPeserta: "",
        kehadiran: "",
        waktuPelaksanaan: "",
        nama_lengkap: "",
        nama_rpl: "",
        mata_uji: ""
      },
      formDataDokumen: {
        dokumenPendukungRplPesertaRequest : [
          {
            idDokumenPendukungRpl: "",
            namaDokumen: "",
            statusUpload: "",
            file: "",
          }
        ]
      },
      formData: {
        // data_dokumen: {
        //   namaDokumen: "",
        //   statusUpload: "",
        //   file: "",
        //   idDokumenPendukungRpl: ""
        // },
        id_jadwal_tc: "",
        nama_rpl: "",
        tombol_dokumen_terverifikasi: "",
        mata_uji: "",
        no_anggota: "",
        kehadiran: "",
        nama_lengkap: "",
        nama_level: "",
        waktu_pelaksanaan: "",
        email: "",
        no_handphone: "",
        id_rpl_peserta: ""
      },
      pagination: {
        totalPages: 0
      },
      fields,
      currentPage: 0,
      details: [],
      no: 1,
      baseUrl:"",
      status: false,
      myModal: false,
      modalVerif: false,
      modalEmail: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      content: [],
      loading: true
    };
  },
  mounted() {
    var vm = this;
    this.baseUrl = Utils.baseurlFoUsers();

    vm.getData("0", this.pageSize, "default", this.$route.params.id_jadwal_tc,this.id_sesi)

    $(".multi-select").each(function() {
      $(this).multipleSelect({
        placeholder: $(this).attr("placeholder")
      });
    });
  },
  watch: {
    currentPage: function(val){
      //alert val -1 
      var page = val - 1;
      this.indexed = page * 10;
      this.getData( val - 1, this.pageSize, this.search , this.$route.params.id_jadwal_tc,this.actionTabSesi)
    }
  },
  methods: {
    changeSesi(sesi) { 
      this.actionTabSesi = sesi;
      this.getData("0", this.pageSize, "default", this.$route.params.id_jadwal_tc,sesi);
    },
    aksiVerifikasiDokumen() {
      var vm = this;
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      MasterJadwalTcService.verifikasiDokumenPesertaRpl(this.formDataDokumen)
      .then(response => {
        loader.hide()
        vm.alertSuccess();
        vm.getData("0", this.pageSize, "default", this.$route.params.id_jadwal_tc,this.actionTabSesi);
      }).catch(error => {
        vm.alertError()
        loader.hide();
        // comment console console.log(error)
      });
    },
    dataTidakAda(){
      this.$swal.fire({
          title: "Informasi",
          text: 'File Tidak Ditemukan.',
          icon: "info",
          confirmButtonText: 'Tutup',
          showConfirmButton: true,
      });
    },
    changePageSize(e) {
      // comment console console.log(e.target.value);
      var pageSize = "";

      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", this.pageSize, "default", this.$route.params.id_jadwal_tc, this.search,this.actionTabSesi);
    },
    cariData() {
      this.getData("0", this.pageSize, "default", this.$route.params.id_jadwal_tc, this.search,this.actionTabSesi);
    },
    sisa(event, k) {
      var data = event.target.value.split(".");
      document.getElementById("sisa" + k).value = data[1];
      // comment console console.log(k);
    },
    updateSelect(event) {
      var vm = this;
      this.formData.namaTc = event.namaTc;
    },
    pageChange() {
      this.getData(currentPage);
    },
    sendEmail() {
      this.modalEmail = true;
      this.formEmail.to = "";
      this.formEmail.subject = "";
      this.formEmail.text = "";
      this.formEmail.attacment = "";
      this.fileName = "";
    },
    postDataEmail() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      // comment console console.log(this.formEmail.to);
      DataPesertaService.postSendMessage(this.formEmail)
        .then(response => {
          // comment console console.log(response);
          this.alertSuccessSend();
          loader.hide();
          this.modalEmail = false;
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
          this.alertErrorSend();
        });
    },
    fileUpload(e) {
      this.formEmail.attacment = e.target.files[0];
      this.fileName = e.target.files[0].name;
      // comment console console.log(e.target.files);
    },
    verifikasiDokumen(id_trans_sertifikasi_peserta) {
      this.modalVerif = true;
      this.getDataDokumenRplPeserta(id_trans_sertifikasi_peserta);
      // this.formDataDokumen.idDokumenPendukungRpl = idDokumenPendukungRpl;
      // this.formDataDokumen.statusUpload = statusUpload;
      // this.index = index;
    },
    alertError() {
      this.$swal.fire({
        title: "Peringatan!",
        text: "Data Gagal Disimpan",
        icon: "error",
        showCancelButton: true
      });
    },
    alertErrorSend() {
      this.$swal.fire({
        title: "Peringatan!",
        text: "Email Gagal Dikirim",
        icon: "error",
        showCancelButton: true
      });
    },
    alertSuccess() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Disimpan"
      });
    },
    alertSuccessSend() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Email Telah Terkirim"
      });
    },
 
    getData(currentPage, pageSize, filter ,idJadwalTc,sesi) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      var vm = this;
      MasterJadwalTcService.getJadwalTcPesertaRpl(currentPage, pageSize, filter, idJadwalTc, sesi)
        .then(response => {
          loader.hide();
          // comment console console.log(response.data.data.content);
          vm.items = response.data.data.content;

          vm.pagination.totalPages = response.data.data.totalPages;
          vm.currentPage = response.data.data.pageable.pageNumber + 1;
          vm.idJadwalTc = vm.$route.params.id_jadwal_tc;
          setTimeout(() => loader.hide(), 1000);
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },
    getDataDokumenRplPeserta(idSertifikasiRplPeserta) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      var vm = this;
      MasterJadwalTcService.getDataDokumenRplPeserta(idSertifikasiRplPeserta)
        .then(response => {
          loader.hide();
          // comment console console.log(response);
          this.formDataDokumen.dokumenPendukungRplPesertaRequest = response.data.data;
          // // comment console console.log("ini email " + response.data.data[0].detailUser.email);
          // var email = response.data.data[0].detailUser.email;
          // this.formEmail.to = email;

          var Sertifikasi = response.data.data.idRplPeserta;
          // this.formProsesAdministrasi.idRplPeserta = Sertifikasi;
        })
        .catch(error => {
          loader.hide();
          // vm.alertError();
          // comment console console.log(error);
        });
    },
    putDataDokumenRplPeserta(id_dokumen_pendukung_rpl){
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      var vm = this;
      MasterJadwalTcService.putDataDokumenRplPeserta(id_dokumen_pendukung_rpl)
        .then(response => {
          loader.hide();
          // comment console console.log(response);
          this.formDataDokumen = response.data.data;
          var Sertifikasi = response.data.data[1].idRplPeserta;
          // this.formProsesAdministrasi.idRplPeserta = Sertifikasi;
        })
        .catch(error => {
          loader.hide();
          // vm.alertError();
          // comment console console.log(error);
        });
    },
    getJadwalTcPeserta() {
      var vm = this;
      MasterJadwalTcService.getJadwalTcPesertaRpl("0")
        .then(response => {
          vm.namaTc = response.data.data.content;
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },

    createData() {
      this.myModal = true;
      this.formData = {};
      this.actionPost = "insert";
      this.title = "Tambah";
    },

    updateDataKehadiran(item) {
      this.myModal = true;
      this.formDataKehadiran.nama_lengkap = item.nama_lengkap;
      this.formDataKehadiran.nama_rpl = item.nama_rpl;
      this.formDataKehadiran.idJadwalTc = this.$route.params.id_jadwal_tc;
      this.formDataKehadiran.waktuPelaksanaan = this.actionTabSesi;
      this.formDataKehadiran.mata_uji = item.mata_uji;
      this.formDataKehadiran.kehadiran = item.kehadiran;
      this.formDataKehadiran.idRplPeserta = item.id_trans_sertifikasi_peserta;
      this.title = "Edit";
    },

    putDataKehadiran() {
      var vm = this;
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      MasterJadwalTcService.putKehadiranPesertaRpl(this.formDataKehadiran)
        .then(response => {
          loader.hide();
          vm.myModal = false;
          vm.alertSuccess();
          vm.getData("0", this.pageSize, "default", this.$route.params.id_jadwal_tc,this.actionTabSesi);
          // comment console console.log(response);
        })
        .catch(error => {
          loader.hide();

          // comment console console.log(error);
        });
    },

    insertData(formDataKehadiran) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      this.formData.tanggalPelaksanaan =
      this.formData.tanggalPelaksanaan + " 12:00:00";
      
      /* hapus data jika tidak ada perubahan pada file */
        if (typeof formEmail.attacment === "string") {
          delete formEmail.attacment;
        }
        if (formEmail.attacment === null) {
          delete formEmail.attacment;
        }

      var vm = this;
      MasterJadwalTcService.postJadwalTc(formData)
        .then(response => {
          vm.myModal = false;
          loader.hide();
          vm.alertSuccess();
          vm.getData("0");
        })
        .catch(error => {
          // comment console console.log(error);
          vm.alertError();
        });
    },



    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>